import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {DECLARATIONS} from './app.module.declarations';
import {IMPORTS} from './app.module.imports';
import {PROVIDERS} from './app.module.providers';

@NgModule({
  declarations: DECLARATIONS,
  imports: IMPORTS,
  providers: PROVIDERS,
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts